(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["maerelle-reviews-demo"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('maerelle-demo-reviews')) {
  customElements.define('maerelle-demo-reviews', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready) return;
      this.dataset.ready = 'true';
      const cards = [...this.querySelectorAll('.mr-demo__card')];
      const button = this.querySelector('.mr-demo__more');
      let visible = 3;
      const update = () => {
        cards.forEach((card, index) => { card.hidden = index >= visible; });
        button.hidden = visible >= cards.length;
      };
      button.addEventListener('click', () => {
        const next = cards[visible];
        const revealed = cards.slice(visible, visible + 3);
        visible += 3;
        update();
        revealed.forEach(card => card.classList.add("is-revealing"));
        if (next) next.focus({preventScroll:true});
      });
      update();
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["maerelle-style-stories"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('maerelle-style-stories')){
customElements.define('maerelle-style-stories',class extends HTMLElement{
 connectedCallback(){
  if(this.ready)return;this.ready=true;
  this.track=this.querySelector('.ms-stories__track');this.cards=[...this.track.children];
  if(this.cards.length<2)return;
  this.controller=new AbortController();const signal=this.controller.signal;
  this.motion=matchMedia('(prefers-reduced-motion: reduce)');this.paused=this.motion.matches;
  const controls=this.querySelector('.ms-stories__controls');controls.hidden=false;
  this.pauseButton=this.querySelector('[data-pause]');
  this.sync=()=>{this.pauseButton.textContent=this.paused?this.pauseButton.dataset.play:this.pauseButton.dataset.stop;};this.sync();
  this.cards.forEach(card=>{const clone=card.cloneNode(true);clone.inert=true;clone.setAttribute('aria-hidden','true');clone.removeAttribute('data-shopify-editor-block');this.track.append(clone);});
  this.step=()=>this.cards[1].offsetLeft-this.cards[0].offsetLeft;
  this.index=()=>Math.round(this.track.scrollLeft/this.step());
  this.go=direction=>{let index=this.index()+direction;if(index<0)index=this.cards.length-1;this.track.scrollTo({left:index*this.step(),behavior:this.motion.matches?'instant':'smooth'});};
  this.querySelector('[data-prev]').addEventListener('click',()=>{this.paused=true;this.sync();this.go(-1);},{signal});
  this.querySelector('[data-next]').addEventListener('click',()=>{this.paused=true;this.sync();this.go(1);},{signal});
  this.pauseButton.addEventListener('click',()=>{this.paused=!this.paused;this.sync();},{signal});

  this.track.addEventListener('scroll',()=>{
   this.querySelector('[data-count]').textContent=(this.index()%this.cards.length+1)+' / '+this.cards.length;
   clearTimeout(this.settle);this.settle=setTimeout(()=>{const cycle=this.step()*this.cards.length;if(this.track.scrollLeft>=cycle-1)this.track.scrollTo({left:Math.max(0,this.track.scrollLeft-cycle),behavior:'instant'});},160);
  },{passive:true,signal});
  this.visible=false;this.observer=new IntersectionObserver(entries=>{this.visible=entries[0].isIntersecting;},{threshold:.15});this.observer.observe(this);
  this.holdUntil=0;this.position=this.track.scrollLeft;
  this.track.addEventListener('pointerdown',()=>{this.dragging=true;},{signal});
  window.addEventListener('pointerup',()=>{this.dragging=false;this.holdUntil=performance.now()+2500;},{signal});
  this.track.addEventListener('wheel',()=>{this.holdUntil=performance.now()+2500;},{passive:true,signal});
  this.frame=time=>{
   const delta=Math.min((time-(this.lastTime||time))/1000,.05);this.lastTime=time;
   const hover=matchMedia('(hover:hover)').matches&&this.track.matches(':hover');
   if(!this.paused&&this.visible&&!document.hidden&&!hover&&!this.dragging&&!this.track.contains(document.activeElement)&&time>this.holdUntil){
    const cycle=this.step()*this.cards.length;
    this.position=(this.position+delta*24)%cycle;
    this.track.scrollLeft=this.position;
   }else{this.position=this.track.scrollLeft;}
   this.frameId=requestAnimationFrame(this.frame);
  };this.frameId=requestAnimationFrame(this.frame);
 }
 disconnectedCallback(){cancelAnimationFrame(this.frameId);clearTimeout(this.settle);this.controller?.abort();this.observer?.disconnect();this.track?.querySelectorAll('[aria-hidden="true"]').forEach(el=>{if(el.classList.contains('ms-stories__card'))el.remove();});this.ready=false;}
});}

  } catch(e) { console.error(e); }
})();
})();
